import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import el from "./locales/el.json";
import ro from "./locales/ro.json";
import bg from "./locales/bg.json";
import hu from "./locales/hu.json";
import de from "./locales/de.json";
import fr from "./locales/fr.json";
import it from "./locales/it.json";
import nl from "./locales/nl.json";
import nb from "./locales/nb.json";
import sv from "./locales/sv.json";
import fi from "./locales/fi.json";
import tr from "./locales/tr.json";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      el: { translation: el },
      ro: { translation: ro },
      bg: { translation: bg },
      hu: { translation: hu },
      de: { translation: de },
      fr: { translation: fr },
      it: { translation: it },
      nl: { translation: nl },
      nb: { translation: nb },
      sv: { translation: sv },
      fi: { translation: fi },
      tr: { translation: tr },
    },
    lng: "en",         // Προεπιλογή
    fallbackLng: "en", // Fallback
    interpolation: { escapeValue: false },
  });

export default i18n;
